'use client'

import { useEffect, useMemo } from 'react'

import {
  canParticipateInFanTasks as computeCanParticipateInFanTasks,
  isClubUserSession,
  resolveTasksAccessHintKey
} from '@/features/tasks/fanTasksAccess'
import { useAuthStore } from '@/stores/authStore'

export function useFanTasksAccess() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  const checkAuth = useAuthStore(s => s.checkAuth)

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  const isClubUser = useMemo(() => {
    if (!isAuthenticated) {
      return false
    }
    return isClubUserSession()
  }, [isAuthenticated])

  const canParticipateInFanTasks = useMemo(
    () => computeCanParticipateInFanTasks(isAuthenticated),
    [isAuthenticated]
  )

  const tasksListAuthScope = canParticipateInFanTasks ? 'auth' : 'public'

  const accessHintKey = useMemo(() => {
    if (canParticipateInFanTasks) {
      return null
    }
    return resolveTasksAccessHintKey(isAuthenticated)
  }, [canParticipateInFanTasks, isAuthenticated])

  return {
    isAuthenticated,
    isClubUser,
    canParticipateInFanTasks,
    tasksListAuthScope,
    accessHintKey
  }
}
